<template>
	<div class="filter-list">
		<div class="outputSelectedElement" @click="openList" :class="{active: listState}">
			{{ selected.name }}
		</div>
		<ul  class="list" v-show="listState">
			<li v-for="(key, index) in filterList"
				:key="key.id"
				@click="changeChoice(index)"
			>{{key.name}}</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'map-list',
		props: ['list', 'listPlaceholder'],
		data() {
			return {
				selected: {
					name: this.listPlaceholder
				},
				filterList: this.list,
				listState: false,
			}
		},
		watch: {
			listState() {
				if(this.listState) {
					document.addEventListener('click', this.anotherClick);
				}
			}
		},
		methods: {
			openList() {
				this.listState = !this.listState;
			},
			changeChoice(index) {
				console.log(index);
				if(this.filterList[index].clear) {
					this.selected.name = this.listPlaceholder;
					this.listState = false;
					this.$emit('filter-change', this.filterList[index]);
					return;
				}
				this.selected.name = this.filterList[index].name;
				this.listState = false;
				this.$emit('filter-change', this.filterList[index], this.listPlaceholder);
			},
			anotherClick(e) {
				// console.log('click');
				if($(e.target).closest(this.$el).length) return;
				this.listState = false;
				document.removeEventListener('click', this.anotherClick);

			}
		}
	}
</script>

<style lang="scss">
	.outputSelectedElement {
		border: 1px solid black;
		height: 47px;
		border-radius: 4px;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-align: center;
		align-items: center;
		padding-left: 25px;
		padding-right: 25px;
		width: 100%;
		&:before{
			content: url(../img/arr.svg);
			width: 20px;
			height: 20px;
			position: absolute;
			right: 25px;
			transform: rotate(-180deg);
			animation: 0.3s outputBlockDisabled reverse;
			display: block;
		}
		&.active:before{
			transform: rotate(0deg);
			animation: 0.3s outputBlockActive linear;
		}
	}
	@keyframes outputBlockActive {
		0%{
			transform: rotate(-180deg);
		}
		20%{
			transform: rotate(-144deg);
		}
		40%{
			transform: rotate(-108deg);
		}
		60%{
			transform: rotate(-72deg);
		}
		80%{
			transform: rotate(-36deg);
		}
		100%{
			transform: rotate(0deg);
		}
	}
	@keyframes outputBlockDisabled {
		100%{
			transform: rotate(0deg);
		}
		80%{
			transform: rotate(-36deg);
		}
		60%{
			transform: rotate(-72deg);
		}
		40%{
			transform: rotate(-108deg);
		}
		20%{
			transform: rotate(-144deg);
		}
		0%{
			transform: rotate(-180deg);
		}
	}
	.filter-list{
		position: relative;
		/*max-width: 311px;*/
		width: 100%;

		.list{
			/*display: none;*/
			position: absolute;
			z-index: 1010;
			background-color: #fff;
			border: 1px solid black;
			width: 100%;
			max-height: 235px;
			border-radius: 4px;
			overflow-y: auto;
			li{
				display: none;
				padding-left: 25px;
				padding-right: 25px;
				height: 47px;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-align: center;
				align-items: center;
			}
			li:not(:last-child) {
				border-bottom: 1px solid black;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// leaflet.vue?758ae0ce